import React from 'react';

import styled from 'styled-components';

import ChargingProfileList from './ChargingProfile/ChargingProfileList';

interface IOperationsChargingProfiles {
  mode: string;
}

const OperationsChargingProfiles = ({
  mode,
}: IOperationsChargingProfiles): any => {
  return mode === 'charging_profiles' ? (
    <OperationsChargingProfilesWrapper>
      <ChargingProfileList />
    </OperationsChargingProfilesWrapper>
  ) : null;
};

const OperationsChargingProfilesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
`;

export default OperationsChargingProfiles;
